import { render, staticRenderFns } from "./FinishedHistoryCreate.vue?vue&type=template&id=35a424bd&scoped=true&"
import script from "./FinishedHistoryCreate.vue?vue&type=script&lang=js&"
export * from "./FinishedHistoryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a424bd",
  null
  
)

export default component.exports